import { StyledDrawerBody } from 'baseui/drawer'
import { styled, withStyle } from 'parkdepot-shared/theme'

export const DrawerBody = withStyle(StyledDrawerBody, ({ $theme }) => ({
    margin: $theme.sizing.scale700
}))

export const HelpTitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    margin: 0
}))

export const ExplanationContainer = styled('ol', ({ $theme }) => ({
    paddingTop: $theme.sizing.scale600,
    margin: 0,
    listStyle: 'circle',
    paddingInlineStart: $theme.sizing.scale700
}))

export const ExplanationItem = styled('li', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    marginBottom: $theme.sizing.scale100
}))

export const ExampleContainer = styled('div', ({ $theme }) => ({
    marginTop: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale500
}))

export const ExampleTitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    margin: 0
}))

export const ExampleItemContainer = styled('ol', ({ $theme }) => ({
    margin: 0,
    listStyle: 'none',
    paddingInlineStart: $theme.sizing.scale500
}))

export const ExampleItem = styled('li', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    marginBottom: $theme.sizing.scale550,
    display: 'flex',
    alignItems: 'center',
    gap: $theme.sizing.scale700
}))

export const ExampleItemText = styled('p', () => ({
    margin: 0
}))

export const ExamplePlateItem = styled('img', () => ({
    height: '21px',
    width: '95px'
}))
